// 融合了 fastCode 和 fnv1a 的快速哈希，高性能低碰撞
export function fastHash(str: string): string {
  let fastHash = 0x81_1c_9d_c5
  let fnv1aHash = 0x81_1c_9d_c5
  const len = str.length
  for (let i = 0; i < len; i++) {
    const char = str.codePointAt(i)
    if (char == null) continue
    fastHash = (fastHash << 5) - fastHash + char
    fastHash |= 0
    fnv1aHash ^= char
    fnv1aHash = (fnv1aHash * 0x1_00_01_93) & 0xff_ff_ff_ff
  }
  fastHash = fastHash >>> 0
  fnv1aHash = fnv1aHash >>> 0
  return '' + fastHash + fnv1aHash
}
